var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"titleText ma-0 pa-0"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"value ma-0 pa-0"},[_vm._v(_vm._s(_vm.value === 'Sem Dados' ? _vm.value : ("+" + _vm.value + "%")))])])}
var staticRenderFns = []

export { render, staticRenderFns }